import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { IntroductionComponent } from './introduction/introduction.component';
import { JalasoftFoundationComponent } from './jalasoft-foundation/jalasoft-foundation.component';
import { IntroBenefitsComponent } from './intro-benefits/intro-benefits.component';
import { IntroOptionsComponent } from './intro-options/intro-options.component';
import { SkillsDevelopmentComponent } from './skills-development/skills-development.component';
import { InvitationComponent } from './skills-invitation/skills-invitation.component';
import { SkillsDatesComponent } from './skills-dates/skills-dates.component';
import { SkillsRequirementComponent } from './skills-requirement/skills-requirement.component';
import { CareerInformationComponent } from './career-information/career-information.component';
import { CampusFirstComponent } from './campus-first/campus-first.component';
import { KeyBenefitsComponent } from './key-benefits/key-benefits.component';


@NgModule({
  declarations: [
    HomeComponent,
    IntroductionComponent,
    JalasoftFoundationComponent,
    IntroBenefitsComponent,
    IntroOptionsComponent,
    SkillsDevelopmentComponent,
    InvitationComponent,
    SkillsDatesComponent,
    SkillsRequirementComponent,
    CareerInformationComponent,
    CampusFirstComponent,
    KeyBenefitsComponent,
  ],
  imports: [
    CommonModule
  ]
})
export class HomeModule { }
